import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router,
} from "@angular/router";
import { OrganizationLevelPermissions } from "../models/organizationLevelPermissions";
import { AuthService } from "../services/auth.service";
import { RoutePaths } from "../shared/constants/routePaths.constants";

@Injectable({
    providedIn: "root",
})
export class CanAccessPageGuard {
    private hasRedirected: boolean = false;

    constructor(
        private authService: AuthService,
        private router: Router,
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): boolean {
        const currentUser = this.authService.getCurrentUser();

        if (currentUser && currentUser.organizationLevelPermissions) {
            const permissions: OrganizationLevelPermissions =
                currentUser.organizationLevelPermissions;

            if (route.routeConfig?.path === "" && !this.hasRedirected) {
                this.hasRedirected = true;
                this.router.navigate([this.authService.getLandingPageUrl()]);
                return false;
            }

            const requiredPermission = route.data
                .requiredPermission as keyof OrganizationLevelPermissions;
            if (permissions && permissions[requiredPermission]) {
                return true;
            }

            this.router.navigate([RoutePaths.unauthorized]);
        }
        return false;
    }
}
